<template>
  <div id="contenedor-proyectos-responsables-validador">
    <v-menu
      offset-y
      top
      :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <div
          id="contenedor-responsables-validaciones"
          class="rounded-lg pa-3" style="border: 1px solid #eee;"
          v-bind="attrs"
          v-on="on">
          <v-row no-gutters>
            <v-col
              cols="auto">
              <span class="font-weight-medium">
                Validaciones
              </span>
              <v-chip
                small
                class="font-weight-medium"
                :color="getPorcentajeValidacion >= 100 ? 'scucess' : ''">
                {{ getCantidadResponsablesValido }} de {{ getCantidadResponsables }}
                <v-icon
                  v-if="getPorcentajeValidacion >= 100"
                  small
                  right
                  color="success">
                  mdi-check
                </v-icon>
              </v-chip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="auto">
              <v-icon>
                mdi-menu-down
              </v-icon>
            </v-col>
          </v-row>
          <div class="d-block my-2">
            <v-progress-linear
              :color="getPorcentajeValidacion >= 100 ? 'scucess' : 'warning'"
              rounded
              height="8"
              :value="getPorcentajeValidacion">
            </v-progress-linear>
          </div>
        </div>
      </template>
      <v-card width="100%">
        <v-list dense nav>
          <v-list-item
            v-for="responsable in mixListadoProyectoResponsables"
            :key="responsable.id"
            :disabled="!responsable.funcionario.usuario
              || $auth.user.id !== responsable.funcionario.usuario.id"
            @click="mixValidarProyectoResponsable(responsable.id)">
            <v-list-item-icon
              class="mr-2">
              <v-icon
                :color="responsable.fechaValido !== null ? 'success' : ''">
                {{ responsable.fechaValido !== null
                  ? 'mdi-check-bold'
                  : 'mdi-clock-time-eight-outline' }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ responsable.funcionario.nombre }}
                <template v-if="responsable.funcionario.usuario !== null
                  && $auth.user.id === responsable.funcionario.usuario.id">
                  <span class="font-weight-medium">
                    (Tu)
                  </span>
                </template>
              </v-list-item-title>
              <v-list-item-subtitle
                v-if="responsable.fechaValido">
                Fecha validación:
                {{ new Date(responsable.fechaValido).toLocaleDateString() }},
                {{ new Date(responsable.fechaValido).toLocaleTimeString() }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import PROYECTO_RESPONSABLES from '@/graphql/querys/administracion/control-proyectos/responsables/proyectoResponsables.gql';
import VALIDAR_PROYECTO_RESPONSABLE from '@/graphql/mutations/administracion/control-proyectos/responsables/validarProyectoResponsable.gql';

export default {
  name: 'ProyectoResponsablesValidador',
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  apollo: {
    proyectoResponsables: {
      query: PROYECTO_RESPONSABLES,
      variables() {
        return {
          idProyecto: this.idProyecto,
        };
      },
    },
  },
  methods: {
    async mixValidarProyectoResponsable(id) {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: VALIDAR_PROYECTO_RESPONSABLE,
          variables: {
            id,
          },
          update: (store, { data: { validarProyectoResponsable } }) => {
            const query = {
              query: PROYECTO_RESPONSABLES,
              variables: {
                idProyecto: this.idProyecto,
              },
            };

            const data = store.readQuery(query);
            const { proyectoResponsables } = data;
            const index = proyectoResponsables
              .findIndex((responsable) => responsable.id
              === id);
            if (index !== -1) {
              proyectoResponsables.splice(index, 1, validarProyectoResponsable);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
    },
  },
  computed: {
    mixListadoProyectoResponsables() {
      if (!this.proyectoResponsables) return [];
      return this.proyectoResponsables;
    },
    getCantidadResponsables() {
      if (!this.proyectoResponsables) return 0;
      return this.proyectoResponsables.length;
    },
    getCantidadResponsablesValido() {
      if (!this.proyectoResponsables) return 0;
      return this.proyectoResponsables.filter(({ fechaValido }) => fechaValido !== null).length;
    },
    getPorcentajeValidacion() {
      return (this.getCantidadResponsablesValido / this.getCantidadResponsables) * 100;
    },
  },
};
</script>

<style lang="scss">
#contenedor-responsables-validaciones:hover {
  background-color: #F5F5F5;
}
</style>
